import { useEffect, useState } from "react";
import SearchBar from "../../../../components/searchBar";
import { removeAllOccurances } from "../../../../utils/arrayUtils";
import { EditPieceStepProps } from "../dashboardEditPiece";
import EditPieceInstrumentElement from "./components/editPieceInstrumentElement";

import { InstrumentAmountDTOInstrumentEnum } from "../../../../openapi-generated-client";
import EditPieceSearchInstrumentElement from "./components/editPieceSearchInstrumentElement";
import EditPieceInstrumentationList from "./components/editPieceInstrumentationList";
import Checkbox from "../../../../components/checkbox";
import OptionChooser from "../../../../components/optionChooser";
import { InstrumentationType } from "../../../../data/instrumentManager";

const MAX_INSTRUMENTS_SHOWN = 5;

export default function EditPieceInstrumenation(props: EditPieceStepProps) {

    var shownInstrumentsCount = 0;

    const [type, setType] = useState<InstrumentationType>(props.piece.orchestralInstruments != undefined ? InstrumentationType.OrchestralPiece : props.piece.instruments.length == 1 ? InstrumentationType.Solo : InstrumentationType.ChamberMusic);
    const [canRemoveAccordion, setCanRemoveAccordion] = useState(false);

    useEffect(() => {
        if(props.piece.instruments.find(instrument => instrument.instrument == InstrumentAmountDTOInstrumentEnum.Accordion) != undefined && props.piece.orchestralInstruments != undefined && props.piece.orchestralInstruments.find(instrument => instrument.instrument == InstrumentAmountDTOInstrumentEnum.Accordion) != undefined) {
            setCanRemoveAccordion(true);
        }else {
            setCanRemoveAccordion(false);
        }
    }, [props.piece])

    const [search, setSearch] = useState("");
    const [searchActive, setSearchActive] = useState(false);



    return <>
        <h2>Instrumentation</h2>

        <OptionChooser className="instrumentation-type-chooser" label="Type" options={Object.values(InstrumentationType)} active={type} setActive={(v: string) => {
            setType(v as InstrumentationType);
            switch(v as InstrumentationType) {
                case InstrumentationType.Solo:
                    props.setPiece({...props.piece, orchestralInstruments: undefined, instruments: [{
                        instrument: InstrumentAmountDTOInstrumentEnum.Accordion,
                        amount: 1
                    }]});
                    break;
                case InstrumentationType.ChamberMusic:
                    props.setPiece({...props.piece, orchestralInstruments: undefined});
                    break;
                case InstrumentationType.OrchestralPiece:
                    props.setPiece({...props.piece, orchestralInstruments: []});
                    break;
        }
        }}/>
        {
            props.piece.orchestralInstruments != undefined ? <div className="instrumentation-rows">
                <div className="solists">
                    <p className="quotation">solist instruments</p>
                    <EditPieceInstrumentationList instruments={props.piece.instruments} setInstruments={(instruments) => {
                        props.setPiece({...props.piece, instruments: instruments});
                    }} canRemoveAccordion={canRemoveAccordion}/>
                </div>
                <div className="orchestra">
                    <p className="quotation">orchestra instruments</p>
                    <EditPieceInstrumentationList instruments={props.piece.orchestralInstruments} setInstruments={(instruments) => {
                        props.setPiece({...props.piece, orchestralInstruments: instruments});
                    }} canRemoveAccordion={canRemoveAccordion}/>

                </div>
            </div> : type != InstrumentationType.Solo ? 
            <>
                <p className="quotation">Please list all the instruments included.</p>
                <EditPieceInstrumentationList instruments={props.piece.instruments} setInstruments={(instruments) => {
                    props.setPiece({...props.piece, instruments: instruments});
                }} canRemoveAccordion={canRemoveAccordion}/>
            </> : <></>
        }

        {type != InstrumentationType.Solo ? <>
        <SearchBar onFocus={setSearchActive} search={search} grey onSearch={setSearch} placeholder="Enter instrument name"/>
        <div className="instrument-search-result-list">
            {Object.values(InstrumentAmountDTOInstrumentEnum).map((e, i) => {
                if(!searchActive && search.length === 0) return;
                if(i == 0) return;
                if(!e.toLowerCase().includes(search.toLowerCase())) return;

                var elements = [];

                if(type == InstrumentationType.OrchestralPiece && props.piece.orchestralInstruments != undefined) {
                    if(props.piece.orchestralInstruments!.find(instrument => instrument.instrument == e) == undefined) {
                        if(shownInstrumentsCount++ >= MAX_INSTRUMENTS_SHOWN) return;
                        elements.push(<EditPieceSearchInstrumentElement onClick={() => {
                            setSearch("");
                            const newInstrumentation = [...props.piece.orchestralInstruments!, {instrument: e, amount: 1}];
                            props.setPiece({...props.piece, orchestralInstruments: newInstrumentation});
                        }} instrument={e}/>);
                    }
                    
                }

                if(props.piece.instruments!.find(instrument => instrument.instrument == e) != undefined) return elements;
                if(shownInstrumentsCount++ >= MAX_INSTRUMENTS_SHOWN) return elements;

                elements.push(<EditPieceSearchInstrumentElement onClick={() => {
                    console.log("click");
                    setSearch("");
                    const newInstrumentation = [...props.piece.instruments, {instrument: e, amount: 1}];
                    props.setPiece({...props.piece, instruments: newInstrumentation});
                }} instrument={e} suffix={type==InstrumentationType.OrchestralPiece ? " as Solist" : undefined}/>);

                return elements;
            })}
        </div>
        </> : <p className="quotation">This piece is a solo piece, so it only includes one instrument, the accordion.</p>}

    </>;

}

export {MAX_INSTRUMENTS_SHOWN};